var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('document-title',{attrs:{"document":_vm.document}}),_vm._v("\n  ("),_c('document-link',{attrs:{"document":_vm.document,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.document.document_id)+" ")]),_vm._v(")\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }